import React from "react";
import Image from "../../../containers/assets/icon_collapse.svg";

function CollapseButton(props) {
  return (
    <button className="icon-zoom" onClick={props.onClick}>
      <img src={Image} className="icon" alt="Collapse button" />
    </button>
  );
}

export default CollapseButton;



// WEBPACK FOOTER //
// ./src/components/ceo/decisions/collapse-button.js